import { useState, useCallback, useEffect } from 'react';

/**
 * Next.jsでメディアクエリを使用するためのフック
 * SSR時にwindowが存在しないことを考慮し、クライアントサイドでのみ動作する。
 * 画面幅が指定値以下になったらtrueを返し、レスポンシブ対応の表示切り替えに利用する。
 *
 * @param width ブレークポイントとなる画面幅（px）
 * @returns 画面幅が指定値以下の場合true
 */
const useMediaQuery = (width: number) => {
  const [targetReached, setTargetReached] = useState(false);

  /** メディアクエリの変化時に状態を更新するコールバック */
  const updateTarget = useCallback((e: MediaQueryListEvent) => {
    if (e.matches) {
      setTargetReached(true);
    } else {
      setTargetReached(false);
    }
  }, []);

  // マウント時にメディアクエリリスナーを登録し、アンマウント時に解除する
  // SSR環境ではwindowが存在しないため、typeofチェックでガードする
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const media = window.matchMedia(`(max-width:${width}px)`);
      media.addEventListener('change', updateTarget);

      if (media.matches) {
        // 初回表示時点ですでに条件を満たす場合も状態を同期しておく。
        setTargetReached(true);
      }

      return () => media.removeEventListener('change', updateTarget);
    }
    return undefined;
  }, []);

  return targetReached;
};

export default useMediaQuery;
